module.exports = __webpack_public_path__ + "media/3_19.32f81300.wav";